<template>
  <div class="overallStats">
    <div class="stat-cards">
      <div class="stat-card">
        <p class="stat-value">{{ data.chargingSessions }}</p>
        <p class="stat-title">Ladevorgänge</p>
      </div>
      <div class="stat-card">
        <p class="stat-value">{{ data.cost }} <span class="stat-unit">€/100 km</span></p>
        <p class="stat-title">⌀ Kosten</p>
      </div>
      <div class="stat-card full-width">
        <p class="stat-value">{{ data.consumption }} <span class="stat-unit">kWh/100 km</span></p>
        <p class="stat-title">⌀ Verbrauch</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      data: {
        consumption: 0.0,
        cost: 0.0,
        chargingSessions: 0
      },
      loading: true,
      error: null
    }
  },
  mounted () {
    this.fetchStatistics()
  },
  methods: {
    async fetchStatistics () {
      try {
        const response = await axios.get('/api/getOverallStatistics.php')
        this.data = response.data
      } catch (error) {
        this.error = 'Fehler beim Laden der Statistiken'
        console.error('Statistik-Fehler:', error)
      } finally {
        this.loading = false
      }
    },
    fakeUpdate (userInput) {
      console.log('fakeUpdate ausgelöst mit Daten:', userInput, new Date().getTime())
      // Überprüfe, ob die gefahrene Strecke > 0 ist
      if (!userInput.distanceDriven || userInput.distanceDriven <= 0) {
        console.error('Die gefahrene Strecke muss größer als 0 sein.')
        console.log(userInput.distanceDriven)
        return
      }

      // Konvertiere bestehende Daten in Zahlen
      const currentSessions = Number(this.data.chargingSessions) || 0
      const currentCost = Number(this.data.cost) || 0
      const currentConsumption = Number(this.data.consumption) || 0

      // Konvertiere User-Eingaben in Zahlen
      const sessionCost = Number(userInput.cost) || 0
      const sessionDistance = Number(userInput.distanceDriven) || 0
      const sessionEnergy = Number(userInput.energy) || 0

      // Berechnung der neuen Werte
      const newTotalSessions = currentSessions + 1

      const newCost =
    (currentCost * currentSessions + (sessionCost / sessionDistance) * 100) /
    newTotalSessions

      const newConsumption =
    (currentConsumption * currentSessions +
      (sessionEnergy / sessionDistance) * 100) /
    newTotalSessions

      // Update der Daten im Frontend
      this.data.chargingSessions = newTotalSessions
      this.data.cost = parseFloat(newCost.toFixed(2)) // Kosten auf zwei Dezimalstellen runden
      this.data.consumption = parseFloat(newConsumption.toFixed(2)) // Verbrauch auf zwei Dezimalstellen runden
    }

  }
}
</script>
